import { twMerge } from 'tailwind-merge';
import { type HTMLMotionProps, m } from 'motion/react';

type THamburgerButton = React.HTMLProps<HTMLButtonElement> &
  HTMLMotionProps<'button'> & {
    isOpened: boolean;
    displayBackground: boolean;
  };

const BASE_LINE_CLASSNAMES = 'w-full absolute right-0 top-0 h-1 rounded-full';

const hiddenLine = {
  rest: {
    opacity: 0,
    rotate: '0deg',
    originX: 0,
    translate: '100%',
  },
  animate: {
    opacity: 1,
    rotate: '45deg',
    translate: '100%',
  },
};

const topLine = {
  rest: {
    rotate: '0deg',
    originX: 1,
  },
  animate: {
    rotate: '-45deg',
    origin: 'top right',
  },
};

const middleLine = {
  rest: {
    opacity: 1,
    originX: 1,
  },
  hover: {
    opacity: 0,
    scaleX: 0,
  },
  animate: {
    opacity: 0,
    scaleX: 0,
  },
};

const bottomLine = {
  rest: { rotate: '0deg', originX: 1 },
  animate: {
    rotate: '45deg',
    scaleX: 1,
  },
};

export const HamburgerButton = ({ isOpened, displayBackground, ...props }: THamburgerButton) => {
  const color = isOpened || displayBackground ? 'bg-foreground' : 'bg-foreground/90';

  return (
    <m.button
      type="button"
      className="relative w-6 h-5"
      aria-label={isOpened ? 'Zamknij menu' : 'Otwórz menu'}
      {...props}
      initial="rest"
      animate={isOpened ? 'animate' : 'rest'}
      whileHover="hover"
    >
      <m.div className={twMerge(BASE_LINE_CLASSNAMES, color, 'w-1/3 left-0')} variants={hiddenLine} />
      <m.div className={twMerge(BASE_LINE_CLASSNAMES, color, 'w-full')} variants={topLine} />
      <m.div className={twMerge(BASE_LINE_CLASSNAMES, color, 'w-2/3 mt-2')} variants={middleLine} />
      <m.div className={twMerge(BASE_LINE_CLASSNAMES, color, 'w-1/3 mt-4')} variants={bottomLine} />
    </m.button>
  );
};
